












































import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { User } from '@/types';
import { ApiResponse } from 'apisauce';
import api from '@/api';
import ActivityIndicator from '@/components/ActivityIndicator.vue';

interface Board {
    id:     null|number;
    title:  string;
    status: null|number;
}
@Component({
  components: {ActivityIndicator},
})
export default class Post extends Vue {
  @State public user!: User;

  public board: Board = {
    id: null,
    title: '',
    status: null,
  };
  public post = {
    title: '',
    body: '',
    loading: false,
    apiError: '',
  };

  public mounted() {
    api.get(`/boards/${this.$route.params.board_id}`)
    .then((res: ApiResponse<any>) => {
      if (res.ok) {
        this.board = res.data.payload;
      }
      this.board.status = res.status || 500;
    });
  }

  // TODO: add requirements for posting fields like length
  public onSubmit() {
      
      if (!this.user.token) {
          return this.post.apiError = 'You are not logged in';
      }
      this.post.apiError = '';
      this.post.loading = true;
    api.setHeader('Authorization', this.user.token);
    api.post(`/posts/${this.board.id}`, this.post)
      .then((res: ApiResponse<any>) => {
        const body = res.data;

        if (res.ok) {
          this.$router.push({
            name: 'post',
            params: {
              post_id: body.payload.id,
            },
          });
        } else {
          this.post.apiError = body.errors
            ? body.errors.join(', ') + '.'
            : 'Failed to communicate with our servers. Please try again later.';
        }

        this.post.loading = false;
      });
  }
}
